import { post, get } from 'src/tools/server';
const getDigitalMarketing = (uuid) => {
  return get<any>(`/portal/setting/salesChannel/digitalMarketing/${uuid}`, {});
};
const postDigitalMarketing = (uuid, body): Promise<any> => {
  return post<any>(
    `/portal/setting/salesChannel/digitalMarketing/${uuid}`,
    body,
    {},
  );
};

const checkMetaTag = (uuid, body): Promise<any> => {
  return post<any>(
    `/portal/setting/salesChannel/digitalMarketing/metaTag/${uuid}/check`,
    body,
    { returnWholeData: true, handleErrorAsResolve: true },
  );
};

export { getDigitalMarketing, postDigitalMarketing, checkMetaTag };
